import {
  RenderTooltipTriggerProps,
  Tooltip,
  TooltipProps,
} from "@jugl-web/ui-components/cross-platform/Tooltip";
import {
  ClickAwayListener,
  cx,
  useAppVariant,
  useTranslations,
} from "@jugl-web/utils";
import { FC, ReactElement } from "react";

export interface SpotlightTooltipProps {
  isOpen: boolean;
  tip: React.ReactNode;
  placement: TooltipProps["placement"];
  showButton?: boolean;
  className?: string;
  renderTrigger: (props: RenderTooltipTriggerProps) => ReactElement;
  onDismiss: () => void;
}

export const SpotlightTooltip: FC<SpotlightTooltipProps> = ({
  isOpen,
  tip,
  placement,
  className,
  showButton = true,
  renderTrigger,
  onDismiss,
}) => {
  const { t } = useTranslations();
  const { isDemo } = useAppVariant();

  return (
    <Tooltip
      isOpen={!isDemo && isOpen}
      placement={placement}
      renderTrigger={renderTrigger}
      className={cx("w-[250px] bg-dark/90 px-4 py-[14px]", className)}
    >
      <ClickAwayListener onClickAway={onDismiss}>
        <span className="text-base leading-[22px]">{tip}</span>
        {showButton && (
          <button
            type="button"
            className="mt-[18px] block cursor-pointer border-0 bg-transparent p-0 font-primary text-base leading-3 font-bold text-primary-200"
            onClick={onDismiss}
          >
            {t({ id: "common.okay", defaultMessage: "Okay" })}
          </button>
        )}
      </ClickAwayListener>
    </Tooltip>
  );
};
